export default __webpack_public_path__ + "static/media/patient-icon.d311bc9d.svg";